// Firestore: companies/{companyId}/firstRun
import { doc, getDoc, setDoc, serverTimestamp } from "firebase/firestore";

export async function getTimeTrackingConfigured(db, companyId) {
  if (!db || !companyId) return false;
  const ref = doc(db, "companies", companyId, "firstRun", "flags");
  const snap = await getDoc(ref);
  return snap.exists() ? !!snap.data()?.timeTrackingConfigured : false;
}

export async function setTimeTrackingConfigured(db, companyId) {
  if (!db || !companyId) return;
  const ref = doc(db, "companies", companyId, "firstRun", "flags");
  await setDoc(ref, { timeTrackingConfigured: true }, { merge: true });
}
// SCHEDULING — has the employer completed first configuration?
export async function getSchedulingConfigured(db, companyId) {
  const ref = doc(db, `companies/${companyId}/firstRun`, "scheduling");
  const snap = await getDoc(ref);
  return !!snap.data()?.configured;
}

export async function setSchedulingConfigured(db, companyId) {
  const ref = doc(db, `companies/${companyId}/firstRun`, "scheduling");
  await setDoc(
    ref,
    { configured: true, updatedAt: serverTimestamp() },
    { merge: true }
  );
}

// --- Expense first-run flag ---
export async function getExpenseConfigured(db, companyId) {
  const ref = doc(db, `companies/${companyId}/firstRun`, "expense");
  const snap = await getDoc(ref);
  return !!snap.data()?.configured;
}

export async function setExpenseConfigured(db, companyId) {
  const ref = doc(db, `companies/${companyId}/firstRun`, "expense");
  await setDoc(
    ref,
    { configured: true, updatedAt: serverTimestamp() },
    { merge: true }
  );
}
// --- Payroll first-run flag ---
export async function getPayrollConfigured(db, companyId) {
  const ref = doc(db, `companies/${companyId}/firstRun`, "payroll");
  const snap = await getDoc(ref);
  return !!snap.data()?.configured;
}

export async function setPayrollConfigured(db, companyId) {
  const ref = doc(db, `companies/${companyId}/firstRun`, "payroll");
  await setDoc(
    ref,
    { configured: true, updatedAt: serverTimestamp() },
    { merge: true }
  );
}

// --- Help Desk / SLA first-run flag ---
export async function getHelpdeskSlaConfigured(db, companyId) {
  if (!db || !companyId) return false;
  const ref = doc(db, `companies/${companyId}/firstRun`, "helpdeskSla");
  const snap = await getDoc(ref);
  return !!snap.data()?.configured;
}

export async function setHelpdeskSlaConfigured(db, companyId) {
  if (!db || !companyId) return;
  const ref = doc(db, `companies/${companyId}/firstRun`, "helpdeskSla");
  await setDoc(
    ref,
    { configured: true, updatedAt: serverTimestamp() },
    { merge: true }
  );
}
